import {ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel} from '../shared';
import {AppLoginContainerModelUpdate} from '../../../../../models/aggregates/id';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

export class ProfileRequestCriteria {
  hdr_guids: string[];
  principalType?: string;
  principalStatus?: string;
  principalId?: string;
  rank?: string;
  calcTotalRecords?: boolean;
  limit?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TenantUserProfilesService extends BaseApiTemplateService<AppLoginContainerModelUpdate> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IDENTITY_MODULE_PREFIX + 'user-profiles';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IDENTITY_MODULE_PREFIX + 'user-profiles';
    this.httpClient = http;
  }

  updateImage(formData: FormData, imageGuid, httpOptions: { headers: HttpHeaders }) {
    console.log(this.apiUrl + 'photo', formData);
    return this.httpClient.put(this.apiUrl + '/photo/replace/' + imageGuid, formData, httpOptions);
  }

  uploadImage(formData: FormData, subjectGuid, httpOptions: { headers: HttpHeaders }) {
    console.log(this.apiUrl + 'photo', formData);
    return this.httpClient.post(this.apiUrl + '/photo/' + subjectGuid, formData, httpOptions);
  }

  getFile(imageGuid: string, visa: ApiVisa): string {
    return visa.api_domain_url +
      'core2/tnt/dm/user-profile/photo/' +
      imageGuid +
      '?tenantCode=' +
      visa.tenantCode +
      '&jwtToken=' +
      visa.jwt_secret;
  }

  public deleteMultiple(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/delete-custom/tenant-ep';
    }

    const httpOptions = this.getHttpHeader(visa);
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');

    // Use httpClient.request to send a DELETE request with a body
    return this.httpClient.request('delete', this.apiUrl, {
      ...httpOptions,
      body: dtoObject
    });
  }

  getProfileByGuids(body: ProfileRequestCriteria, apiVisa: ApiVisa): Observable<PagingResponseModel<AppLoginContainerModelUpdate>> {
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpoint_path + '/query/backoffice-ep';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/query/backoffice-ep';
    }
    return this.httpClient.post<PagingResponseModel<AppLoginContainerModelUpdate>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }
}
